/**
 * Lazy-evaluation eligibility marker returned by `GET /api/v1/bonuses`.
 * Backend no longer eagerly materializes LOCKED placeholders — every row
 * carries an `eligibility` that tells the frontend how to render it and
 * which select endpoint (if any) to call.
 */
export enum BonusEligibilityEnum {
    /** Real `user_bonuses` row. Use `status` and the legacy select endpoint. */
    MATERIALIZED = 'MATERIALIZED',
    /** Audience + trigger matched; nothing in the DB yet. Activate via the
     *  strategy/bonus select endpoint to materialize. */
    OFFERED_AVAILABLE = 'OFFERED_AVAILABLE',
    /** Audience matches but trigger hasn't fired (e.g. needs a deposit).
     *  Render as a teaser with `lockReason` — no Activate button. */
    OFFERED_LOCKED = 'OFFERED_LOCKED',
}
